import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Building2, Plus, Pencil, Trash2, Mail, Phone } from "lucide-react";

const DeveloperRow = ({ dev, onEdit, onDelete }) => (
  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 py-3" data-testid={`developer-row-${dev.id}`}>
    <div className="min-w-0">
      <p className="font-semibold text-slate-900 truncate" data-testid={`developer-company-${dev.id}`}>{dev.company_name}</p>
      <p className="text-sm text-slate-600 truncate">{dev.name}</p>
      <div className="flex flex-wrap gap-x-4 text-xs text-slate-500 mt-0.5">
        <span className="inline-flex items-center gap-1"><Mail className="w-3 h-3" />{dev.email}</span>
        {dev.mobile && <span className="inline-flex items-center gap-1"><Phone className="w-3 h-3" />{dev.mobile}</span>}
      </div>
    </div>
    <div className="flex items-center gap-2 shrink-0">
      <span className="text-xs font-semibold rounded-full bg-amber-100 text-amber-800 px-2.5 py-1" data-testid={`developer-count-${dev.id}`}>
        {dev.dwelling_count} dwelling{dev.dwelling_count === 1 ? "" : "s"}
      </span>
      <Button size="icon" variant="ghost" onClick={() => onEdit(dev)} aria-label="Edit developer" data-testid={`developer-edit-${dev.id}`}>
        <Pencil className="w-4 h-4" />
      </Button>
      <Button size="icon" variant="ghost" onClick={() => onDelete(dev)} aria-label="Delete developer" className="text-red-600 hover:text-red-700" data-testid={`developer-delete-${dev.id}`}>
        <Trash2 className="w-4 h-4" />
      </Button>
    </div>
  </div>
);

export const DevelopersPanel = ({ developers, onAdd, onEdit, onDelete }) => (
  <Card className="dashboard-card" data-testid="developers-panel">
    <CardHeader className="flex flex-row items-center justify-between space-y-0">
      <CardTitle className="flex items-center gap-2 text-lg"><Building2 className="w-5 h-5 text-amber-600" />Developers</CardTitle>
      <Button size="sm" onClick={onAdd} className="btn-construction" data-testid="add-developer-button">
        <Plus className="w-4 h-4 mr-1" />Add Developer
      </Button>
    </CardHeader>
    <CardContent>
      {developers.length === 0 ? (
        <p className="text-sm text-slate-500 py-2" data-testid="developers-empty">
          No developers yet. Add one if a developer owns some or all of this site's dwellings.
        </p>
      ) : (
        <div className="divide-y divide-slate-100">
          {developers.map((d) => <DeveloperRow key={d.id} dev={d} onEdit={onEdit} onDelete={onDelete} />)}
        </div>
      )}
    </CardContent>
  </Card>
);
